import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';

const ConfirmExitDialog = ({ isOpen, onConfirm, onCancel }) => {
    return (
        <Dialog
            open={isOpen}
            onClose={onCancel}
            fullWidth={true}     
            maxWidth="md"         
            aria-labelledby="confirm-exit-title"
            aria-describedby="confirm-exit-description"
        >
            <DialogTitle id="confirm-exit-title">
                End Interview
            </DialogTitle>

            <DialogContent>
                <DialogContentText id="confirm-exit-description">
                    If you exit now, your progress will be lost and you cannot return to this interview. Are you sure?
                </DialogContentText>
            </DialogContent>

            <DialogActions>
                <Button onClick={onCancel} color="inherit">
                    Cancel
                </Button>
                <Button onClick={onConfirm} color="error" variant="contained" autoFocus>
                    Yes, End Interview
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmExitDialog;